import { useCallback } from 'react'
import type { JSX } from 'react'
import type { HTMLAttributes } from 'react'

type PreviewAvatarProps = {
  src: string
  fallbackUrl: string
} & HTMLAttributes<HTMLDivElement>

/**
 * Renders the avatar/fallback background pair used across the Instagram Reel and
 * Story previews. The two image URLs are dynamic, so they are applied as the
 * --avatar-src / --avatar-fallback custom properties that the caller's class
 * reads via var(). The visual shape (round vs. square) comes entirely from the
 * incoming `className`.
 */
export const PreviewAvatar = ({
  src,
  fallbackUrl,
  ...rest
}: PreviewAvatarProps): JSX.Element => {
  const setAvatarVars = useCallback(
    (node: HTMLDivElement | null): void => {
      if (!node) return
      node.style.setProperty('--avatar-src', `url(${src})`)
      node.style.setProperty('--avatar-fallback', `url(${fallbackUrl})`)
    },
    [src, fallbackUrl],
  )

  return <div ref={setAvatarVars} {...rest} />
}
